module.exports = __webpack_public_path__ + "img/collaborate_36.43728aae.jpg";